
function NoMatch(){
    return (
        <>
            404
        </>
    )
}

export default NoMatch